import React from 'react';
import { IconProps } from '.';

const SvgComment = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15 19h7V3H2v16h7l3 4 3-4Zm-3 1.5 2.25-3h6.25v-13h-17v13h6.25l2.25 3Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='M13 13.75H7v-1.5h6v1.5ZM17 9.75H7v-1.5h10v1.5Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgComment;
